import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-time-dropdown',
  templateUrl: './time-dropdown.component.html',
  styleUrls: ['./time-dropdown.component.css']
})
export class TimeDropdownComponent implements OnInit {
  timeList: any[];
  @Output() onSelect = new EventEmitter<string>();
  constructor() {
    this.timeList = [
      {label:'(none)',value:null},
      {label:'00:00 AM',value:'0:0'},
      {label:'00:30 AM',value:'0:30'},
      {label:'01:00 AM',value:'1:0'},
      {label:'01:30 AM',value:'1:30'},
      {label:'02:00 AM',value:'2:0'},
      {label:'02:30 AM',value:'2:30'},
      {label:'03:00 AM',value:'3:0'},
      {label:'03:30 AM',value:'3:30'},
      {label:'04:00 AM',value:'4:0'},
      {label:'04:30 AM',value:'4:30'},
      {label:'05:00 AM',value:'5:0'},
      {label:'05:30 AM',value:'5:30'},
      {label:'06:00 AM',value:'6:0'},
      {label:'06:30 AM',value:'6:30'},
      {label:'07:00 AM',value:'7:0'},
      {label:'07:30 AM',value:'7:30'},
      {label:'08:00 AM',value:'8:0'},
      {label:'08:30 AM',value:'8:30'},
      {label:'09:00 AM',value:'9:0'},
      {label:'09:30 AM',value:'9:30'},
      {label:'10:00 AM',value:'10:0'},
      {label:'10:30 AM',value:'10:30'},
      {label:'11:00 AM',value:'11:0'},
      {label:'11:30 AM',value:'11:30'},

      {label:'12:00 PM',value:'12:0'},
      {label:'12:30 PM',value:'12:30'},
      {label:'1:00 PM',value:'13:0'},
      {label:'1:30 PM',value:'13:30'},
      {label:'2:00 PM',value:'14:0'},
      {label:'2:30 PM',value:'14:30'},
      {label:'3:00 PM',value:'15:0'},
      {label:'3:30 PM',value:'15:30'},
      {label:'4:00 PM',value:'16:0'},
      {label:'4:30 PM',value:'16:30'},
      {label:'5:00 PM',value:'17:0'},
      {label:'5:30 PM',value:'17:30'},
      {label:'6:00 PM',value:'18:0'},
      {label:'6:30 PM',value:'18:30'},
      {label:'7:00 PM',value:'19:0'},
      {label:'7:30 PM',value:'19:30'},
      {label:'8:00 PM',value:'20:0'},
      {label:'8:30 PM',value:'20:30'},
      {label:'9:00 PM',value:'21:0'},
      {label:'9:30 PM',value:'21:30'},
      {label:'10:00 PM',value:'22:0'},
      {label:'10:30 PM',value:'22:30'},
      {label:'11:00 PM',value:'23:0'},
      {label:'11:30 PM',value:'23:30'}
    ]
   }

  _selectedValue:any;

  ngOnInit() {
  }

  @Input()
  set selectedValue(value:string){
    console.log(value);
    this._selectedValue = value;
  }

  chageTime(){
    this.onSelect.emit(this._selectedValue);
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/layout/time-dropdown/time-dropdown.component.ts